import React, { useCallback, useState } from "react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import { Skeleton, Button, RequiredMark } from "components";
import { underwritingMerchantInfoWarn } from "validators/applicationValidators";

import { ReactComponent as CancelIcon } from "static/images/cancel.svg";
import { ReactComponent as CheckDone } from "static/images/checked.svg";
import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "../../merchantInfo.module.scss";

const FORM_NAME = "merchantForm";

let InlineEditableField = ({
	label,
	value,
	loading,
	submitForm,
	handleSubmit,
	onEditCancel,
	isEditable,
	component,
}) => {
	const [showEditField, setShowEditField] = useState(false);

	const FieldWithLoader = useCallback(
		({ text }) => {
			if (loading) {
				return (
					<Skeleton
						variant="text"
						marginRight="15px"
						height="24px"
						width="90%"
					/>
				);
			} else {
				return <p className={styles.content}>{text}</p>;
			}
		},
		[loading],
	);

	const handleCancelEdit = () => {
		setShowEditField(!showEditField);
		onEditCancel && onEditCancel();
	};

	return (
		<>
			<Form
				onSubmit={handleSubmit(values => {
					submitForm(values, () => setShowEditField(!showEditField));
				})}
			>
				<div className={styles.merchantFormDesc}>
					<p className={styles.merchantLabel}>
						{label} {showEditField && <RequiredMark />}
					</p>
					<div className={styles.formContent}>
						{showEditField ? (
							<>
								{component}
								<div className={styles.wrappIcons}>
									<Button
										onClick={() => {
											handleCancelEdit();
										}}
										icon={<CancelIcon />}
										btnIcon
										variant="secondary-danger"
										size="sm"
									/>
									<Button
										type="submit"
										icon={<CheckDone />}
										btnIcon
										variant="secondary"
										size="sm"
									/>
								</div>
							</>
						) : (
							<>
								<FieldWithLoader text={value || ""} />
								{isEditable && (
									<Button
										onClick={() => {
											setShowEditField(!showEditField);
										}}
										icon={<EditIcon />}
										btnIcon
										variant="secondary"
										size="sm"
									/>
								)}
							</>
						)}
					</div>
				</div>
			</Form>
		</>
	);
};

export default connect(state => ({
	initialValues: state.merchantInfo.merchantInfo,
}))(
	reduxForm({
		form: FORM_NAME,
		destroyOnUnmount: false,
		enableReinitialize: true,
		warn: underwritingMerchantInfoWarn,
	})(InlineEditableField),
);
